import type { MouseEvent } from 'react';
import {
  ShoppingCartPlusIcon,
  BellPlusIcon,
  ArrowRightIcon,
} from '@grupoboticario/flora-react-icons';
import { FloraButton } from '@grupoboticario/flora-react';
import { Link } from 'react-router-dom';

import type { UnavailableButtonProps } from './Product.components.d';

export const UnavailableButton = ({
  isBuyIntention,
  isBuyIntentionFeatureActive,
  name,
  productCode,
  setBuyIntention,
  isResaleIntention,
  isAutoStartEnabled,
  hasSimilar,
  slugName,
  onClick,
  tracking,
  ...props
}: UnavailableButtonProps) => {
  const handleBuyIntention = () => setBuyIntention(productCode, name);

  if (hasSimilar) {
    return (
      <Link
        to={{
          pathname: `/produto/${slugName}`,
          search: `?sku=${productCode}`,
          hash: '#similares',
        }}
      >
        <FloraButton
          hierarchy="secondary"
          isFull
          data-autotagging-flora-section="produtos_similares"
          data-flora="button"
          data-flora-text={`ver-similares${tracking?.origin ? `-${tracking.origin}` : ''}`}
          autotagging-flora="on"
          icon={<ArrowRightIcon size={24} />}
          onClick={onClick}
          {...props}
        >
          Ver similares
        </FloraButton>
      </Link>
    );
  }

  if (isBuyIntentionFeatureActive) {
    return (
      <FloraButton
        onClick={handleBuyIntention}
        hierarchy="secondary"
        isFull
        disabled={isResaleIntention && !isAutoStartEnabled}
        data-testid="button-unavailable-isbuyintention"
        aria-label={`avise-me quando o ${name} estiver disponível`}
        data-flora="button"
        data-flora-text="avise-me"
        icon={isBuyIntention ? <ShoppingCartPlusIcon size={24} /> : <BellPlusIcon size={24} />}
        {...props}
      >
        Avise-me
      </FloraButton>
    );
  }

  return (
    <FloraButton
      aria-label={'sem estoque'}
      hierarchy="secondary"
      disabled
      isFull
      data-testid="button-unavailable-without-products"
      {...props}
    >
      Sem estoque
    </FloraButton>
  );
};
